"use strict";
var core_1 = require('@angular/core');
var moment = require('moment');
var DurationPipe = (function () {
    function DurationPipe() {
    }
    DurationPipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof args === 'undefined' || args.length !== 1) {
            throw new Error('DurationPipe: missing required time unit argument');
        }
        return moment.duration(value, args[0]).humanize();
    };
    DurationPipe.decorators = [
        { type: core_1.Pipe, args: [{ name: 'amDuration' },] },
    ];
    /** @nocollapse */
    DurationPipe.ctorParameters = [];
    return DurationPipe;
}());
exports.DurationPipe = DurationPipe;
//# sourceMappingURL=duration.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-moment/duration.pipe.js
// module id = 397
// module chunks = 3